import { RouteName } from '@/router/config'
import { TabsEnum } from '@/views/center/security/const'
import { useI18n } from '@/i18n'
import Modal from '@/controller/Modal'
import router from '@/router'

/**
 * 显示 强制修改提现密码弹窗
 */
export function showForceChangeWidthdrawPasswordDialog() {
  const { t } = useI18n()
  Modal.create({
    title: t('lobby.common.tips.title'),
    titlePosition: 'left',
    closable: false,
    content: t('lobby.modal.reset_withdraw_password'),
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    },
    onOk: () => {
      router.push({
        name: RouteName.SECURITY,
        query: {
          current: TabsEnum.WITHDRAWPASS.toString()
        }
      })
    }
  })
}
